import { Files } from 'lucide-react';

// İSG: çok sayfalı PDF'i hemen fark etsin (birleşik belge olabilir)
export const PageCountBadge = ({ info, testId }) => (info?.page_count > 1 ? (
  <span title="Çok sayfalı belge – birleşik olabilir, gerekirse Sayfa Ayır ile ayırın" data-testid={testId}
    className="inline-flex items-center gap-0.5 whitespace-nowrap rounded-full border border-orange-300 bg-orange-100 px-1.5 py-px text-[10px] font-bold text-orange-700">
    <Files className="h-3 w-3" />{info.page_count} sayfa
  </span>
) : null);
